var _slicedToArray = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require('../utils/utils'),
    fixedEncodeURIComponent = _require.fixedEncodeURIComponent,
    replaceSpaceByUnderscores = _require.replaceSpaceByUnderscores,
    isPlainObject = _require.isPlainObject;

var _require2 = require('./helpers'),
    isPropertyId = _require2.isPropertyId;

var wikidataBase = 'https://www.wikidata.org/wiki/';

var languages = require('./sitelinks_languages');

var getSitelinkUrl = function getSitelinkUrl(site, title) {
  if (isPlainObject(site)) {
    title = site.title;
    site = site.site;
  }

  if (!site) throw new Error('missing a site');
  if (!title) throw new Error('missing a title');
  var shortSiteKey = site.replace(/wiki$/, '');
  var specialUrlBuilder = siteUrlBuilders[shortSiteKey] || siteUrlBuilders[site];
  if (specialUrlBuilder) return specialUrlBuilder(title);

  var _getSitelinkData = getSitelinkData(site),
      lang = _getSitelinkData.lang,
      project = _getSitelinkData.project;

  title = fixedEncodeURIComponent(replaceSpaceByUnderscores(title));
  return "https://".concat(lang, ".").concat(project, ".org/wiki/").concat(title);
};

var wikimediaSite = function wikimediaSite(subdomain) {
  return function (title) {
    return "https://".concat(subdomain, ".wikimedia.org/wiki/").concat(title);
  };
};

var siteUrlBuilders = {
  commons: wikimediaSite('commons'),
  mediawiki: function mediawiki(title) {
    return "https://www.mediawiki.org/wiki/".concat(title);
  },
  meta: wikimediaSite('meta'),
  species: wikimediaSite('species'),
  wikidata: function wikidata(title) {
    if (isPropertyId(title)) return "".concat(wikidataBase, "Property:").concat(title);
    return "".concat(wikidataBase).concat(title);
  }
};

var getSitelinkData = function getSitelinkData(site) {
  var specialProjectName = specialSites[site];
  if (specialProjectName) return {
    lang: 'en',
    project: specialProjectName
  };

  var _site$split = site.split('wik'),
      _site$split2 = _slicedToArray(_site$split, 3),
      lang = _site$split2[0],
      projectSuffix = _site$split2[1],
      rest = _site$split2[2]; // Detecting cases like 'frwikiwiki' that would return [ 'fr', 'i', 'i' ]


  if (rest != null) throw new Error("invalid sitelink: ".concat(site));

  if (languages.indexOf(lang) === -1) {
    throw new Error("sitelink lang not found: ".concat(lang));
  }

  var project = projectsBySuffix[projectSuffix];
  if (!project) throw new Error("sitelink project not found: ".concat(project));
  return {
    lang: lang,
    project: project
  };
};

var specialSites = {
  commonswiki: 'commons',
  mediawikiwiki: 'mediawiki',
  metawiki: 'meta',
  specieswiki: 'specieswiki',
  wikidatawiki: 'wikidata'
};

var isSitelinkKey = function isSitelinkKey(site) {
  try {
    // relies on getSitelinkData validation
    getSitelinkData(site);
    return true;
  } catch (err) {
    return false;
  }
};

var projectsBySuffix = {
  i: 'wikipedia',
  isource: 'wikisource',
  iquote: 'wikiquote',
  tionary: 'wiktionary',
  ibooks: 'wikibooks',
  iversity: 'wikiversity',
  ivoyage: 'wikivoyage',
  inews: 'wikinews'
};
module.exports = {
  getSitelinkUrl: getSitelinkUrl,
  getSitelinkData: getSitelinkData,
  isSitelinkKey: isSitelinkKey
};